module.exports = __webpack_public_path__ + "img/CM-EC-25-Lincoln-Established.72fb9b7f.jpg";